import { useRef } from 'react';
import domtoimage from 'dom-to-image';
import { Tweet } from 'react-tweet';
import { getTwitterIdFromUrl } from '../../../utils/ge-tweet-id-from-url';
import { base64ToFile } from '../../../utils/base64-to-file';
import { ImageSource } from './types';

export function TweetActions({ url, onImageChange }: { url: string } & ImageSource) {
    const tweetRef = useRef<HTMLDivElement>(null);

    const setScreenshot = async () => {
        if (tweetRef.current) {
            domtoimage
                .toPng(tweetRef.current, { quality: 100 })
                .then((dataUrl: string) => {
                    const file = base64ToFile(dataUrl, 'postImage.jpg');

                    onImageChange(dataUrl, file);
                })
                .catch((error) => {
                    console.error('Screenshot failed!', error);
                });
        }
    };

    const downloadScreenshot = async () => {
        if (tweetRef.current) {
            domtoimage
                .toPng(tweetRef.current, { quality: 100 })
                .then((dataUrl: string) => {
                    const link = document.createElement('a');
                    link.href = dataUrl;
                    link.download = 'tweet-screenshot.png';
                    link.click();
                })
                .catch((error) => {
                    console.error('Screenshot failed!', error);
                });
        }
    };

    return (
        <>
            <div>
                <div className='set-btn-case'>
                    <button className='set-btn' onClick={setScreenshot} data-tooltip='Capture & Set Screenshot'></button>
                </div>
                <div className='download-btn-case'>
                    <button className='download-btn' onClick={downloadScreenshot} data-tooltip='Capture & Download Screenshot'></button>
                </div>
            </div>
            <div className='tweetForm'>
                <div data-theme='dark' style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
                    <div
                        className='screen-tweet-form'
                        ref={tweetRef}
                        style={{
                            position: 'absolute',
                            overflow: 'hidden',
                            top: 0,
                            left: 0,
                            zIndex: 1,
                        }}
                    >
                        <div className='form1'>
                            <Tweet id={getTwitterIdFromUrl(url)} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
